import { SERVICEURI } from "../const/serviceuri";
import { deleteTelemetryApiInstance, getTelemetryApiInstance, postFormTelemetryApiInstance, postTelemetryApiInstance } from "../instance/fetchtelemetryapiInstance";
import data from "../components/MachineDetails/MyProductivity/Productivity/productivitydata.json";
import { getIntegrationApiInstance, postIntegrationApiInstance } from "../instance/fetchintegrationapiInstance";
import { getFrameworkApiInstance, postFrameworkApiInstance } from "../instance/fetchframeworkapiInstance";
import helperfunctions from "../utils/helperfunctions";


const getMachineSuggestions = (searchQuery: string): Promise<any> => {
    const endPoint = SERVICEURI.GetMachineSuggestions?.replace("{searchquery}", searchQuery);

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getMachineDetailsById = (machineId: string): Promise<any> => {
    const endPoint = SERVICEURI.GetMachineDetailsById?.replace("{machineId}", encodeURIComponent(machineId.trim()));

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const GetGeneralAttributes = (machineId: string): Promise<any> => {
    const endPoint = SERVICEURI.GetGeneralAttributesById?.replace("{machineId}", encodeURIComponent(machineId));

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const GetMyLocationDetails = (machineId: string, startDate: string, endDate: string, isGallon: any): Promise<any> => {
    let endPoint = SERVICEURI.GetMyLocationDetails?.replace("{machineid}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    endPoint = endPoint.replace("{isGallon}", isGallon);

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const GetOperationStatus = (machineId: string, isGallon: string): Promise<any> => {
    let endPoint = SERVICEURI.GetOperationStatus?.replace("{machineId}", encodeURIComponent(machineId)).replace("{isGallon}", isGallon);
    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const GetOperationStatusMining = (machineId: string, isGallon: string, type: string): Promise<any> => {
    let endPoint = SERVICEURI.GetOperationStatusMining?.replace("{machineId}", encodeURIComponent(machineId)).replace("{isGallon}", isGallon).replace("{type}", type);
    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const getOperationStatusHistory = (machineId: string, startDate: string, endDate: string, isGallon: string): Promise<any> => {
    let endPoint = SERVICEURI.GetOperationStatusHistory?.replace("{machineId}", machineId)
        .replace("{startDate}", startDate)
        .replace("{endDate}", endDate)
        .replace("{isGallon}", isGallon);

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getOperationStatusHistoryMining = (machineId: string, startDate: string, endDate: string, isGallon: string): Promise<any> => {
    let endPoint = SERVICEURI.GetOperationStatusHistoryMining?.replace("{machineId}", encodeURIComponent(machineId))
        .replace("{startDate}", startDate)
        .replace("{endDate}", endDate)
        .replace("{isGallon}", isGallon)

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const GetMyUtilizationDetails = (machineId: string, startDate: string, endDate: string, utilizationView: any, isGallon: any): Promise<any> => {
    let endPoint = SERVICEURI.GetMyUtilization?.replace("{machineid}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    endPoint = endPoint.replace("{isGrid}", utilizationView);
    endPoint = endPoint.replace("{isGallon}", isGallon);

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const GetMyUtilizationMiningDetails = (machineId: string, startDate: string, endDate: string, utilizationView: any, isGallon: any): Promise<any> => {
    let endPoint = SERVICEURI.GetMyUtilizationMining?.replace("{machineid}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    endPoint = endPoint.replace("{viewName}", utilizationView);
    endPoint = endPoint.replace("{isGallon}", isGallon);

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const UnitNumber = (machineId: any, data: any): Promise<any> => {
    // post method
    let endPoint = SERVICEURI.UnitNumber?.replace("{machineId}", encodeURIComponent(machineId));
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const myHealthSummary = (machineId: string, startDate: string, endDate: string, isMining: boolean = false): Promise<any> => {
    const uri = SERVICEURI.GetHealthSummary
    let endPoint = uri?.replace("{machineId}", encodeURIComponent(machineId))
        .replace("{startDate}", startDate)
        .replace("{endDate}", endDate);
    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const myHealthRecommendation = (model: string, serial: string): Promise<any> => {
    let endPoint = SERVICEURI.GetHealthRecommandation?.replace("{model}", encodeURIComponent(model)).replace("{serial}", serial);
    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const GetAbnormalities = (machineId: string, startDate: string, endDate: string, filter: string = "", isOem: boolean = false, isMining: boolean = false, searchKey: string = ''): Promise<any> => {
    const uri = isMining ? SERVICEURI.GetAbnormalitiesMining : SERVICEURI.GetAbnormalities;
    let endPoint = uri?.replace("{machineid}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    const searchKeyWord = searchKey ? searchKey.toLocaleLowerCase() : '';
    const filterType = isOem ? "severityLevel" : "actionLevel";
    if (filter === "") {
        if (searchKeyWord) {
            endPoint = endPoint + `&filter=contains(tolower(actionLevel),'${searchKeyWord}') or contains(tolower(eventCodes),'${searchKeyWord}') or contains(tolower(subSystem),'${searchKeyWord}')`;
        } else {
            endPoint = endPoint + "&count=true";
        }
    } else if (filter === "5") {
        endPoint = endPoint + "&top=5&count=true";
    } else if (!searchKeyWord) {
        endPoint = endPoint + `&filter=${filterType} eq '${filter}'&count=true`;
    } else if (searchKeyWord) {
        if (filter) {
            endPoint = endPoint + `&filter=${filterType} eq '${filter}' and (contains(tolower(actionLevel),'${searchKeyWord}') or contains(tolower(eventCodes),'${searchKeyWord}') or contains(tolower(subSystem),'${searchKeyWord}'))`
        } else {
            endPoint = endPoint + `&filter=contains(tolower(actionLevel),'${searchKeyWord}') or contains(tolower(eventCodes),'${searchKeyWord}') or contains(tolower(subSystem),'${searchKeyWord}')`;
        }
    }

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const GetProductivityDetails = (machineId: string) => {
    return Promise.resolve(data);
};


const getRegenerationHistory = (machineId: string, startDate: string, endDate: string, isGallon: string = "true"): Promise<any> => {
    let endPoint = SERVICEURI.GetRegenerationHitory?.replace("{machineid}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    endPoint = endPoint.replace("{isGallon}", isGallon);
    endPoint = endPoint + "&count=true";

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getRegenerationHistoryChart = (machineId: string, startDate: string, endDate: string): Promise<any> => {
    let endPoint = SERVICEURI.GetRegenerationHitoryChart?.replace("{machineid}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    endPoint = endPoint + "&count=true";

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const getRegenerationCautionHistory = (machineId: string, startDate: Date, endDate: Date): Promise<any> => {
    let endPoint = SERVICEURI.GetRegenerationCautionHitory?.replace("{machineid}", encodeURIComponent(machineId));
    endPoint = endPoint.replace(
        "{startDate}",
        startDate.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }).replace(/\//g, "-")
    );
    endPoint = endPoint.replace(
        "{endDate}",
        endDate.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }).replace(/\//g, "-")
    );
    endPoint = endPoint + "&count=true";

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getRegenerationDetails = (machineId: string, startDate: Date, endDate: Date, isGallon: string = "true"): Promise<any> => {
    let endPoint = SERVICEURI.GetRegenerationDetails?.replace("{machineid}", encodeURIComponent(machineId));
    endPoint = endPoint.replace(
        "{startDate}",
        startDate.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }).replace(/\//g, "-")
    );
    endPoint = endPoint.replace(
        "{endDate}",
        endDate.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }).replace(/\//g, "-")
    );
    endPoint = endPoint.replace("{isGallon}", isGallon);
    endPoint = endPoint + "&count=true";

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const getPartsBookUrl = (data: any): Promise<any> => {
    const endPoint = SERVICEURI.GetPartsBookUrl;

    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const GetMyTrends = (data: any): Promise<any> => {
    const endPoint = SERVICEURI.GetMyTrends;
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const GetMyTrendsMining = (machineId: string, startDate: string, endDate: string): Promise<any> => {
    let endPoint = SERVICEURI.GetMyTrendsMining?.replace("{machineId}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    return new Promise((onSucess, onFailure) => {
        getTelemetryApiInstance(endPoint)
            .then((response) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};

const GetMyTrendsDropdown = (machineId: string, startDate: string, endDate: string) => {
    let endPoint = SERVICEURI.GetMyTrendsDropdown?.replace("{machineId}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    return new Promise((onSucess, onFailure) => {
        getTelemetryApiInstance(endPoint)
            .then((response) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};


const GetCompareTrend = (data: any): Promise<any> => {
    const endPoint = SERVICEURI.GetTrendsCompare;
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const GetCompareTrendMining = (data: any): Promise<any> => {
    const endPoint = SERVICEURI.GetTrendsCompareMining?.replace("{machineId}", encodeURIComponent(data.machineId))?.replace("{startDate}", data.startDate)?.replace("{endDate}", data.endDate);
    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getRecommendationPartNoOptions = (model: string, maintenanceRecommendation: string): Promise<any> => {
    let endPoint = SERVICEURI.GetHealthRecommendationPartNoOptions?.replace("{model}", model)?.replace(
        "{maintenanceRecommnedation}",
        maintenanceRecommendation
    );
    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const recommendationAddToCart = (data: any): Promise<any> => {
    let endPoint = SERVICEURI.PostRecommendationAddtoCart;
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const UpdateTrendThreshold = (data: any): Promise<any> => {
    const endPoint = SERVICEURI.UpdateTrend;
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getOrderKowaKitListing = (machineId: string, distributorCode: string): Promise<any> => {
    let endPoint = SERVICEURI.GetOrderKowaKitListing?.replace("{machineId}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{distributorCode}", distributorCode);

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const kowaAddToCart = (data: any): Promise<any> => {
    let endPoint = SERVICEURI.PostKowaAddToCart;
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const getIMCSummaryDetails = (machineId: string, startDate: string, endDate: string, isGallon: string = "true"): Promise<any> => {
    let endPoint = SERVICEURI.GetIMCSummaryDetails?.replace("{machineId}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    endPoint = endPoint.replace("{isGallon}", isGallon);
    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getIMCGridDetails = (machineId: string, startDate: string, endDate: string, isGallon: string = "true"): Promise<any> => {
    let endPoint = SERVICEURI.GetIMCGridDetails?.replace("{machineId}", encodeURIComponent(machineId));
    endPoint = endPoint.replace("{startDate}", startDate);
    endPoint = endPoint.replace("{endDate}", endDate);
    endPoint = endPoint.replace("{isGallon}", isGallon);

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const GetCareReport = (machineId: any): Promise<any> => {
    let endPoint = SERVICEURI.GetCareReport?.replace("{machineId}", encodeURIComponent(machineId));
    return new Promise((resolve, reject) => {
        getIntegrationApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getCartCount = (): Promise<any> => {
    let endPoint = SERVICEURI.GetCartCount;
    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const PostMachinesListForReport = async (data: any, filterQuery: any =''): Promise<any> => {
    let endPoint = SERVICEURI.PostMachinesListForReport + filterQuery;
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve({ results: response, data: data });
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getKowaReportList = (data: any): Promise<any> => {
    const endPoint = SERVICEURI.getKowaReportList;
    return new Promise((resolve, reject) => {
        postIntegrationApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getKowaReportDetails = (data: any): Promise<any> => {
    const endPoint = SERVICEURI.getKowaReportDetails;
    return new Promise((resolve, reject) => {
        postIntegrationApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getKowaReportListForHistory = (data: any): Promise<any> => {
    const endPoint = SERVICEURI.getKowaReportListForHistory;
    return new Promise((resolve, reject) => {
        postIntegrationApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const getManageQuickLinks = (userId: string, machineId: string): Promise<any> => {
    const endPoint = SERVICEURI.getManageQuickLinks?.replace("{userId}", userId).replace("{machineId}", encodeURIComponent(machineId));
    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const updateQuickLinksSelected = (userId: string, data: any): Promise<any> => {
    const endPoint = SERVICEURI.updateQuickLinksSelected?.replace("{userId}", userId);
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const SavePartList = (data: any): Promise<any> => {
    const endPoint = SERVICEURI.SavePartList;
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};


const getTreeviewData = (machineId: any, productType: any, isFromAlert: any) => {
    let endPoint = SERVICEURI.getCptTreeData?.replace("{machineId}", encodeURIComponent(machineId))
        .replace("{productType}", productType).replace("{isFromAlert}", isFromAlert);

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getComponentList = (machineId: string, filter: string = "", isExport: any = false, isMining: boolean = false) => {
    const uri = isMining ? SERVICEURI.getCptComponentListMining : SERVICEURI.getCptComponentList;
    let endPoint = uri?.replace("{machineId}", encodeURIComponent(machineId))
        .replace("{isExport}", isExport);
    if (filter === "") {
        endPoint += "&count=true";
    } else {
        if (isMining) {
            endPoint += `&filter=status eq '${filter}' &count=true`;
        } else {
            endPoint += `&filter=ComponentTrackingStatus eq '${filter}' &count=true`;
        }
    }

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const deleteZeroSMRIntervalComponent = (machineId: string) => {
    let endPoint = SERVICEURI.deleteZeroSMRIntervalComponent?.replace("{machineId}", encodeURIComponent(machineId));
    return new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(endPoint, {})
            .then((response) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};

const addComponent = (data: any): Promise<void> => {
    let endPoint = SERVICEURI.addComponentCpt;
    return new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(endPoint, data)
            .then((response: any) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};

const updateComponent = (data: any): Promise<void> => {
    let endPoint = SERVICEURI.updateComponentCpt;
    return new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(endPoint, data)
            .then((response: any) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};

const deleteComponent = (data: any): Promise<void> => {
    let endPoint = SERVICEURI.deleteComponentCpt;
    return new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(endPoint, data)
            .then((response: any) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};

const savectacknowledegement = (userAdId: string): Promise<void> => {
    let endPoint = SERVICEURI.savectacknowledegement.replace("{userID}", userAdId);

    return new Promise((onSucess, onFailure) => {
        postFrameworkApiInstance(endPoint, data)
            .then((response: any) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};

const validateSecondEditOnSMRInterval = (machineId: string, segmentName: string, componentName: string) => {
    let endPoint = SERVICEURI.validateSecondEditCPT
        .replace("{machineid}", encodeURIComponent(machineId))
        .replace("{segmentName}", segmentName)
        .replace("{componentName}", componentName);

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then((response: any) => {
                resolve(response);
            })
            .catch((error: any) => {
                reject(error);
            });
    });
};

const uploadComponentTracking = (file: any, machineId: string) => {
    let endPoint = SERVICEURI.uploadComponentTracking;
    let formData = new FormData();
    formData.append("File", file, file?.name);
    formData.append("MachineId", machineId);
    formData.append("Endpoint", endPoint);

    return new Promise((resolve, reject) => {
        postFormTelemetryApiInstance(endPoint, formData)
            .then((response: any) => {
                resolve(response);
            })
            .catch((error: any) => {
                reject(error);
            });
    });
};


const getComponentFilterData = (
    machineId: string,
    filterCriteria?: any,
    filterOrSortCriteria?: any,
    isExport: any = false
) => {
    let endPoint = SERVICEURI.getCptComponentList?.replace("{machineId}", encodeURIComponent(machineId)).replace("{isExport}", isExport);

    if (filterOrSortCriteria == "filter") {
        const dataFilter = helperfunctions.transformCPTInput(filterCriteria.join(" "));
        endPoint = endPoint + `&$filter=${dataFilter}`;
    } else {
        endPoint = endPoint + `&$orderby=${filterCriteria[0]} ${filterCriteria[1]}`;
    }

    return new Promise((resolve, reject) => {
        getTelemetryApiInstance(endPoint)
            .then((response) => {
                resolve(response);
            })
            .catch((error: any) => {
                reject(error);
            });
    });
};


const GetCountryCodes = () => {
    let endPoint = SERVICEURI.getCountryCodes;
    return new Promise((resolve, reject) => {
        getFrameworkApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const postCompanyPhoneNumber = (data: any, machineId: string) => {
    let endPoint = SERVICEURI.postPhoneNumber?.replace("{machineId}", machineId);
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const updateMaintenance = (machineId: string, data: any) => {
    let endPoint = SERVICEURI.updateMaintenance?.replace("{machineId}", machineId);
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};



const addCustomMaintenance = (data: any): Promise<any> => {
    let endPoint = SERVICEURI.addCustomMaintenance;
    return new Promise((resolve, reject) => {
        postTelemetryApiInstance(endPoint, data)
            .then((response: any) => {
                resolve(response);
            })
            .catch((error: any) => {
                reject(error);
            });
    });
};


const addMaintenanceRecommendation = (data: any): Promise<void> => {
    let endPoint = SERVICEURI.addMaintenanceRecommendation;
    return new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(endPoint, data)
            .then((response: any) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};

const updateMaintenanceRecommendation = (data: any): Promise<void> => {
    let endPoint = SERVICEURI.updateMaintenanceRecommendation;
    return new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(endPoint, data)
            .then((response: any) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};

const deleteMaintenanceRecommendation = (data: any): Promise<any> => {
    let endPoint = SERVICEURI.deleteMaintenanceRecommendation;
    return new Promise((onSuccess, onFailure) => {
        deleteTelemetryApiInstance(endPoint, data)
            .then((response: any) => {
                onSuccess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};

const uploadMaintenanceRecommendation = (file: any, machineId: string): Promise<any> => {
    let endPoint = SERVICEURI.uploadMaintenanceRecommendation;
    let formData = new FormData();
    formData.append("File", file, file?.name);
    formData.append("MachineId", machineId);
    formData.append("Endpoint", endPoint);
    return new Promise((onSuccess, onFailure) => {
        postFormTelemetryApiInstance(endPoint, formData)
            .then((response: any) => {
                onSuccess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
};


const downloadMaintenanceRecommendation = (machineId: string) => {
    let endPoint = SERVICEURI.downloadMaintenanceRecommendationTemplate?.replace("{machineId}", machineId);
    return new Promise((onSuccess, onFailure) => {
        getTelemetryApiInstance(endPoint)
            .then((response) => {
                onSuccess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
}


export default {
    getMachineSuggestions,
    getMachineDetailsById,
    GetGeneralAttributes,
    GetMyLocationDetails,
    GetOperationStatus,
    getOperationStatusHistory,
    UnitNumber,
    GetMyUtilizationDetails,
    GetMyUtilizationMiningDetails,
    myHealthSummary,
    myHealthRecommendation,
    GetAbnormalities,
    getPartsBookUrl,
    GetProductivityDetails,
    getRegenerationHistory,
    getRegenerationHistoryChart,
    getRegenerationCautionHistory,
    getRegenerationDetails,
    getRecommendationPartNoOptions,
    recommendationAddToCart,
    UpdateTrendThreshold,
    GetMyTrendsDropdown,
    GetCompareTrend,
    GetMyTrends,
    GetMyTrendsMining,
    getOrderKowaKitListing,
    kowaAddToCart,
    getKowaReportList,
    getCartCount,
    getIMCSummaryDetails,
    getIMCGridDetails,
    GetCareReport,
    getKowaReportDetails,
    getKowaReportListForHistory,
    PostMachinesListForReport,
    getTreeviewData,
    getComponentList,
    addComponent,
    updateComponent,
    deleteComponent,
    validateSecondEditOnSMRInterval,
    savectacknowledegement,
    SavePartList,
    getComponentFilterData,
    uploadComponentTracking,
    GetCountryCodes,
    postCompanyPhoneNumber,
    getManageQuickLinks,
    updateQuickLinksSelected,
    updateMaintenance,
    addCustomMaintenance,
    addMaintenanceRecommendation,
    updateMaintenanceRecommendation,
    deleteMaintenanceRecommendation,
    uploadMaintenanceRecommendation,
    downloadMaintenanceRecommendation,
    deleteZeroSMRIntervalComponent,
    GetOperationStatusMining,
    getOperationStatusHistoryMining,
    GetCompareTrendMining
};
